import moment from 'moment';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { IMachineEnergy, IMachineJobsFilter } from 'app/models';
import { Constants } from '@config/constants';
import { HttpClient } from '@angular/common/http';
import { catchError, retry } from 'rxjs/operators';
import { ErrorHandlingService } from '../error-handling/error.handling.service';

@Injectable()
export class DataEnergyService {
  constructor(
    private readonly http: HttpClient,
    private readonly constants: Constants,
    private readonly errorHandlingService: ErrorHandlingService
  ) { }

  downloadDataEnergyCSV = (queryParams: string): any =>
    this.http
      .get(
        `${this.constants.DATAENERGY_CSV_ENDPOINT}?${queryParams}`,
        {responseType: 'blob'}
      );

  findAllMachineEnergyByCustomer = (
    customerId: number
  ): Observable<IMachineEnergy[]> =>
    this.http
      .get<IMachineEnergy[]>(
        this.constants.DATAENERGY_BY_CUSTOMER_ENDPOINT + `/${customerId}`
      )
      .pipe(
        retry(this.constants.HTTP_REQUEST_RETRY_TIMES),
        catchError(this.errorHandlingService.handleHttpError)
      );

  getOverallConsumption = ({
    customerId,
    machineId,
    dateRange: { startDate, endDate } = {
      startDate: moment().startOf('day'),
      endDate: moment().endOf('day'),
    },
    zoneId,
  }: IMachineJobsFilter): Observable<number | null | undefined> =>
    this.http
      .get<number>(
        `${this.constants.DATAENERGY_OVERALL_CONSUMPTION_ENDPOINT
        }?customerId=${customerId}&machineId=${machineId}&from=${moment(startDate).format(
          'YYYY-MM-DDTHH:mm:ss'
        )}&to=${moment(endDate).format('YYYY-MM-DDTHH:mm:ss')}&zoneId=${zoneId}`
      )
      .pipe(
        retry(this.constants.HTTP_REQUEST_RETRY_TIMES),
        catchError(this.errorHandlingService.handleHttpError)
      );
}
